export const EDrugInteractionLevel = {
  Light: 'Leve',
  Moderate: 'Moderado',
  Serious: 'Grave',
  Without: 'Sem Interação',
};

export type DrugInteraction = {
  content: string;
  interaction: string;
  labels: {
    drug: string;
    link: string;
    uniqueId: number;
  }[];
  level: string;
  origin: string;
};
